import _get from "lodash/get";
import { css } from 'styled-components';
import typographyTheme from './typographyTheme';

var headingStyles = function headingStyles(_ref) {
  var isUppercase = _ref.isUppercase,
      colorValue = _ref.colorValue,
      theme = _ref.theme;
  return css(["color:", ";display:block;font-family:", ";line-height:", ";padding:0;text-transform:", ";transition:color 0.15s ease-in-out;"], _get(theme, "typography.colors." + colorValue, typographyTheme.typography.colors[colorValue]), function (_ref2) {
    var isBaseFont = _ref2.isBaseFont;
    return isBaseFont ? _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily) : _get(theme, 'typography.headings.fontFamily', typographyTheme.typography.headings.fontFamily);
  }, _get(theme, 'typography.headings.lineHeight', typographyTheme.typography.headings.lineHeight), isUppercase ? 'uppercase' : 'none');
};

export default headingStyles;